// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"56ca7d5d","586":"0c132290"}[chunkId] + ".chunk.js";
};